import React from 'react';
import { motion } from 'framer-motion';

const BrandingSection = () => {
  return (
    <section className="py-8 bg-gradient-to-b from-white to-cream-50">
      <div className="px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="max-w-sm mx-auto"
        >
          {/* Decorative Line */}
          <div className="flex items-center justify-center mb-4">
            <div className="w-8 h-px bg-gold-400"></div>
            <div className="w-2 h-2 bg-gold-400 rounded-full mx-3"></div>
            <div className="w-8 h-px bg-gold-400"></div>
          </div>

          {/* Main Content */}
          <div className="text-center space-y-3">
            <h2 className="text-xs font-medium tracking-[0.4em] text-gold-600">
              PREMIUM LUXURY
            </h2>
            <p className="text-sm font-light text-gray-700 leading-relaxed">
              Timeless elegance meets modern sophistication
            </p>
          </div>

          {/* Bottom Decorative Element */}
          <div className="flex justify-center mt-4">
            <div className="w-12 h-px bg-gradient-to-r from-transparent via-gold-300 to-transparent"></div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default BrandingSection;